import { render } from "./NotificationDrawer.vue?vue&type=template&id=32451b8a&scoped=true&ts=true"
import script from "./NotificationDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationDrawer.vue?vue&type=script&lang=ts"

import "./NotificationDrawer.vue?vue&type=style&index=0&id=32451b8a&scoped=true&lang=css"

import exportComponent from "../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32451b8a"]])

export default __exports__